module.exports = __webpack_public_path__ + "assets/fonts/uu5-glyphicons.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/uu5-glyphicons.eot?n7r5pz
// module id = 77
// module chunks = 0